<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
      >        
        <material-card
          color="blue"
          title="Subscriptions"
          text="Here are your currently configured subscriptions"
        >
          <v-tooltip
            content-class="left"
            left
          >
            <v-btn 
              slot="activator"              
              fab 
              absolute 
              icon 
              round 
              top 
              right 
              @click="showAddSubscriptionDialog=true" 
              color="accent" 
              class="mr-3" 
              style="top:25px;" 
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            Add an new subscription. Go on! You're gonna love it!
          </v-tooltip>

          <div>
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Look for something..."
              single-line
              hide-details
              clearable
            ></v-text-field>
          </div>

          <v-data-table
            :headers="headers"
            :items="atmosSubscriptions"
            :search="search"            
            :pagination.sync="pagination"
          >
            <v-progress-linear v-slot:progress indeterminate></v-progress-linear>            
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-left text-no-wrap">
                <div>
                  <v-icon>mdi-currency-usd</v-icon>
                  <a @click="navigateToDetails(item.id)" style="color:inherit;">{{item.name}}</a>
                </div>
              </td>
              <td class="text-xs-left hidden-sm-and-down">{{item.desc}}</td>
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  @click.stop="navigateToDetails(item.id)"
                  class="mr-2"
                >mdi-pencil</v-icon>
                <v-icon
                  small
                  :disabled="!canDeleteSub"
                  @click.stop="confirmRemoveSub(item)"
                >mdi-delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <dialog-add-subscription 
      v-model="showAddSubscriptionDialog"
    />

    <dialog-confirm 
      v-model="showConfirmRemoveSubDialog" 
      title="Remove Subscription?" 
      :content="`Are you sure you want to remove the subscription '${(currentSub || '').name}'? All data associated with this subscription will be deleted.`"
      :challenge="(currentSub || '').name"
      @confirm="removeApp(currentSub)"
    />

  </v-container>
</template>

<script>
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'
import AddSubscriptionDialog from '@/dialogs/AddSubscriptionDialog'
import ConfirmDialog from '@/dialogs/ConfirmDialog'
import { Sentry } from '@/apis/sentry'

export default {
  components: {
    'dialog-add-subscription': AddSubscriptionDialog,
    'dialog-confirm' : ConfirmDialog,
  },
  
  data() {
    return {
      search: null,
      currentSub: null,
      showConfirmRemoveSubDialog: false,
      showAddSubscriptionDialog: false,
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Description', align: 'left', value: 'type', class: 'hidden-sm-and-down' },
        { text: 'Actions', align: 'center', sortable: false, value: 'name' },
      ],
      pagination: {
        rowsPerPage: 10
      }
    }
  },

  computed: {
    ...mapGetters('atmos', [
      'atmosInitialized',
      'atmosSubscription',
      'atmosSubscriptions',
    ]),
  },

  asyncComputed: {
    async canDeleteSub() {
      return await Sentry.hasPermission('SoftPro.Atmos', 'SoftPro.Atmos/Subscriptions/Delete');
    }
  },

  filters: {
  },

  methods: {
    ...mapActions('atmos', [
    ]),

    navigateToDetails(id) {
      this.$router.push({ name: 'Subscription', params: { id: id } });
    },

    confirmRemoveSub(sub) {
      this.currentSub = sub;
      this.showConfirmRemoveSubDialog = true;
    },

    async removeSub() {
      await this.atmosRemoveSubscription(this.currentSub.name);
    },

  }  

}
</script>
